import {EmblaIcon} from "../emblaIcon/emblaIcon";
import {EmblaIconsType} from "../../emblaIcons";
import classNames from "classnames";
import {BadgePaddingSizes, BadgeTypes} from "./badgeConstants";

type BadgeTypesType = typeof BadgeTypes[keyof typeof BadgeTypes];
type BadgePaddingSizesType = typeof BadgePaddingSizes[keyof typeof BadgePaddingSizes];
type BadgeIconPosition =  "before" | "after";

type InfoBadgePillInputProps = {
    badgeType: BadgeTypesType;
    badgeText?: string | JSX.Element;
    emblaIconName?: EmblaIconsType;
    emblaIconPosition?: BadgeIconPosition;
    emblaIconOnClick?: () => void;
    additionalClasses?: string;
    paddingSize?: BadgePaddingSizesType;
}

const InfoBadgePill = ({
    badgeType, 
    badgeText, 
    emblaIconName,
    emblaIconPosition = "before",
    emblaIconOnClick,
    additionalClasses, 
    paddingSize = BadgePaddingSizes.Xs
}: InfoBadgePillInputProps) => {

    const renderIcon = (iconName: EmblaIconsType) => {
        if (emblaIconOnClick) {
            const iconMarginClassName = emblaIconPosition === "before" ? "margin-right-s" : "margin-left-s";
            const shouldApplyMargin = !!badgeText; // Apply margin when the icon is an action and text is defined.

            return (
                <span 
                    onClick={emblaIconOnClick} 
                    className={classNames(shouldApplyMargin && iconMarginClassName)} 
                    style={{ cursor: "pointer" }}
                >
                    <EmblaIcon iconName={iconName} additionalClasses=""/>
                </span>
            )
        }
        return <EmblaIcon iconName={iconName}/>;
    }

    return (
        <span
            className={classNames("badge badge-pill padding-right-s padding-left-s margin-right-s", badgeType, additionalClasses, paddingSize)}>
              <div>
                  {(emblaIconName && emblaIconPosition === "before") && renderIcon(emblaIconName)}
                  {badgeText && badgeText}
                  {(emblaIconName && emblaIconPosition === "after") && renderIcon(emblaIconName)}
              </div>
          </span>
    )
};

export default InfoBadgePill;
